import { Nullable } from "../types";

export function assert(success: boolean, message: string): void {
  if (!success) {
    throw new Error(`Assertion failed: ${message}`);
  }
}
export function assertNotEmpty<T>(value: Nullable<T>, name: string): T {
  if (value == null || (value as any) === "") {
    throw new Error(`Value cannot be empty: ${name}`);
  }
  return value;
}

export function assertNotNull<T>(
  value: Nullable<T>,
  name = "",
): NonNullable<T> {
  if (value == null) {
    throw new Error(`${name || "value"} must not be empty`);
  }
  return value;
}

export function assertString(value: any, name: string): string {
  if (typeof value !== "string") {
    throw new Error(`Value is not a string: ${name}`);
  }
  return value;
}

export function assertNotNil<T>(val?: T, name = ""): NonNullable<T> {
  if (val == null) {
    throw new Error(`${name || "value"} should not be nil`);
  }
  return val;
}
